import React, { useRef, useState } from "react";
import { Button, Checkbox, Form, Popconfirm, Radio, Select, Space } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import ReactModal from "react-modal-resizable-draggable";
import ReactQuill from "react-quill";
import SpeechToTextButton from "./SpeechToText";
import constants from "../../constants/constants";

const NotesModal = ({
	hideModal,
	notesVisible,
	onchangeNoteValue,
	createNote,
	getForm,
	noteValue,
	noteTypeValue,
	disable,
	date,
	onSessionChange,
	sessionChecked,
	isSessionPresent,
	nextPreviousButton = null,
	isEdit = null,
	assessmentBehavior = null,
	handleAssessmentBehaviorChange = null,
	notefollowUp = false,
	onFollowUpChange = null,
}) => {
	const noteValueRefs = useRef((noteValue || []).map(() => React.createRef()));
	const [activeSpeechIndex, setActiveSpeechIndex] = useState(null);

	const notesHeader = ["DATA:", "ASSESSMENT:", "PLAN:"];
	const initWidth = window.innerWidth <= 768 ? 330 : 800;

	// Speech insertion logic
	const handleSpeechInsert = (index, text) => {
		const quill = noteValueRefs.current[index]?.current?.getEditor();
		if (quill) {
			const range = quill.getSelection(true);
			quill.insertText(range?.index || quill.getLength(), text + " ");
			quill.setSelection((range?.index || quill.getLength()) + text.length + 1);
		}
	};

	// Focus handling logic
	const handleFocus = (index) => {
		const quill = noteValueRefs.current[index]?.current?.getEditor();
		if (quill) {
			const selection = quill.getSelection();
			if (selection === null || selection.length === 0) {
				quill.format("header", 3);
			}
		}
	};

	return (
		<ReactModal
			initWidth={initWidth}
			initHeight={500}
			disableKeystroke
			className="notes-modal"
			onRequestClose={hideModal}
			isOpen={notesVisible}
			disableResize
		>
			{/* Header */}
			<div className="notes-header flex justify-between items-center">
				<h3>
					<strong>Notes</strong>
				</h3>
				<div className="flex">
					{isEdit ? <div>{nextPreviousButton()}</div> : null}
					<Button type="text" icon={<CloseOutlined />} onClick={hideModal} />
				</div>
			</div>

			{/* Type Selection */}
			<div className="flex justify-between items-center pl-3 py-2 pr-7">
				<Radio.Group onChange={(e) => getForm(e.target.value)} value={noteTypeValue}>
					{/* <Radio disabled={disable ? noteTypeValue !== "2" : false} value="2">
						Family Member
					</Radio>
					<Radio disabled={disable ? noteTypeValue !== "1" : false} value="1">
						Addicts/Gamblers
					</Radio>
					<Radio disabled={disable ? noteTypeValue !== "3" : false} value="3">
						Emotional
					</Radio> */}
					<Radio disabled={disable ? noteTypeValue !== "0" : false} value="0">
						General
					</Radio>
				</Radio.Group>
			</div>

			{/* Notes Section */}
			<div className="px-2 pb-2">
				<div className="h-80 overflow-y-auto">
					<div className="flex gap-5 flex-wrap">
						{date}
						<Space>
							<Checkbox
								onChange={(e) => onFollowUpChange(e.target.checked)}
								className="mb-6"
								checked={notefollowUp}
							>
								Follow-up
							</Checkbox>
							<Checkbox
								onChange={(e) => onSessionChange(e.target.checked)}
								className="mb-6"
								checked={sessionChecked}
								disabled={isSessionPresent}
							>
								Session
							</Checkbox>
						</Space>
					</div>

					{/* Notes Loop */}
					{noteValue &&
						noteValue.map((value, index) => {
							const isActive = activeSpeechIndex === index;
							return (
								<div key={index}>
									<Space size="middle">
										<div className="text-lg">
											<b>
												<u>{notesHeader[index]}</u>
											</b>
										</div>

										{/* Speech-to-Text Button */}
										<SpeechToTextButton
											index={index}
											isActive={isActive}
											onStart={() => setActiveSpeechIndex(index)}
											onStop={() => setActiveSpeechIndex(null)}
											onSpeech={(text) => handleSpeechInsert(index, text)}
										/>
									</Space>

									{/* Quill Editor */}
									<ReactQuill
										name={index}
										ref={noteValueRefs.current[index]}
										className={`admin-notes mb-2 ${index === 1 || index === 2 ? 'small-notes' : ''}`}
										theme="snow"
										onChange={(val) => onchangeNoteValue(val, index)}
										value={value}
										placeholder="Write your note here"
										onFocus={() => handleFocus(index)}
										onKeyPress={() => handleFocus(index)}
									/>

									{/* Assessment Behavior Dropdown */}
									{index === 1 && noteTypeValue === "0" && (
										<Form.Item label="Assessment Behavior">
											<Select
												placeholder="Select assessment behavior"
												showSearch
												mode="multiple"
												optionFilterProp="children"
												value={assessmentBehavior}
												onChange={handleAssessmentBehaviorChange}
												filterOption={(input, option) =>
													option?.children?.toLowerCase()?.includes(input.toLowerCase())
												}
											>
												{constants.AssessmentGroupNotesOptions.map((group, groupIndex) => (
													<Select.OptGroup key={groupIndex} label={group.topic}>
														{[...group.options]
															.sort((a, b) => a.localeCompare(b))
															.map((sentence, optionIndex) => (
																<Select.Option key={`${groupIndex}-${optionIndex}`} value={sentence}>
																	{sentence}
																</Select.Option>
															))}
													</Select.OptGroup>
												))}
											</Select>
										</Form.Item>
									)}
								</div>
							);
						})}
				</div>

				{/* Footer Buttons */}
				<div className="absolute left-0 bottom-0 pl-5 pb-4">
					<Space>
						<Button className="bg-sky-800 text-white uppercase" onClick={hideModal}>
							{constants.Cancel}
						</Button>
						<Button className="bg-sky-800 text-white uppercase" onClick={() => createNote("add")}>
							{constants.Save}
						</Button>
						<Popconfirm
							title="You will not be able to Edit after you Esign the Notes"
							onConfirm={() => createNote("esign")}
						>
							<Button className="bg-sky-800 text-white uppercase">{constants.Esign}</Button>
						</Popconfirm>
					</Space>
				</div>
			</div>
		</ReactModal>
	);
};

export default NotesModal;
